import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldAlert, FlaskConical } from "lucide-react";

const KEY = "rsa_compliance_ack_v1";

export const ComplianceGate = () => {
  const [show, setShow] = useState(false);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY) !== "true") {
      setShow(true);
      document.body.style.overflow = "hidden";
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "true");
    document.body.style.overflow = "";
    setShow(false);
    window.dispatchEvent(new Event("rsa-gate-accepted"));
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] bg-ink-900/95 backdrop-blur-md flex items-center justify-center px-5"
          data-testid="compliance-gate"
        >
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="max-w-lg w-full bg-ink-800 border border-[#27272A] clip-corner-lg p-8"
          >
            <div className="flex items-center gap-2.5 mb-6">
              <FlaskConical size={20} className="text-accent" />
              <span className="font-display font-extrabold tracking-tight text-xl">
                RECOVERY SUPPS
                <span className="font-mono-tech text-[9px] tracking-[0.35em] text-zinc-500 font-normal ml-2">
                  AUSTRALIA
                </span>
              </span>
            </div>

            <div className="flex items-center gap-2 text-accent mb-3">
              <ShieldAlert size={16} />
              <span className="font-mono-tech text-[10px] uppercase tracking-[0.25em]">
                Research chemicals · Age-restricted
              </span>
            </div>

            <h2 className="font-display font-black tracking-tighter text-3xl leading-none mb-4">
              BEFORE YOU ENTER
            </h2>

            <p className="text-zinc-300 leading-relaxed text-sm">
              All products sold on this website are supplied strictly{" "}
              <strong className="text-white">for laboratory and research use only</strong>. They are{" "}
              <strong className="text-white">not for human consumption</strong>, are not therapeutic
              goods or supplements, and are not intended to diagnose, treat, cure or prevent any
              disease.
            </p>

            <ul className="mt-5 space-y-2.5">
              {[
                "I am 18 years of age or older.",
                "I am a qualified researcher / purchasing for research purposes only.",
                "I will not administer these products to humans or animals.",
              ].map((t) => (
                <li key={t} className="flex gap-2.5 text-sm text-zinc-300">
                  <span className="h-1.5 w-1.5 bg-accent rounded-full mt-1.5 shrink-0" />
                  {t}
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <button
                onClick={accept}
                className="flex-1 bg-accent hover:bg-accent-hover text-white font-display font-bold uppercase tracking-wide py-4 transition-colors clip-corner"
                data-testid="compliance-accept"
              >
                I Confirm — Enter
              </button>
              <button
                onClick={() => setDenied(true)}
                className="flex-1 border border-white/20 hover:border-white text-zinc-300 font-display font-bold uppercase tracking-wide py-4 transition-colors"
                data-testid="compliance-decline"
              >
                Exit
              </button>
            </div>

            {denied && (
              <p className="font-mono-tech text-[11px] text-zinc-500 mt-4 leading-relaxed">
                You must confirm the above to access this site. If you do not agree, please close this
                page.
              </p>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
